import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';

import { CatalogCovinBadgeComponent } from '@core/ui';

import { SortableCatalog } from '../../models';
import { UpdateButtonComponent } from '../../update-button/update-button.component';

export type UpdateCatalog = {
  catalog: SortableCatalog;
  shouldUpdate: boolean;
};

@Component({
  selector: 'mp-catalog-item-footer',
  templateUrl: './catalog-item-footer.component.html',
  styleUrl: './catalog-item-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CatalogCovinBadgeComponent, UpdateButtonComponent],
})
export class CatalogItemFooterComponent {
  readonly catalog: InputSignal<SortableCatalog> = input.required<SortableCatalog>();

  readonly allowWrite: InputSignal<boolean> = input<boolean>(false);

  readonly itemUpdated: OutputEmitterRef<UpdateCatalog> = output<UpdateCatalog>();

  emitIndustryCatalogUpdate(catalog: SortableCatalog, shouldUpdate: boolean): void {
    this.itemUpdated.emit({ catalog, shouldUpdate });
  }
}
